module.exports = __webpack_public_path__ + "static/images/callout_1.4b8ca53e57d95e3d3528160a5351d74c.jpg";